import { useState, useEffect } from 'react';
import { NavLink, useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi"; 
import Logo from '../assets/logoGU.png';

const clashDisplay = { fontFamily: "'Clash Display', sans-serif" };

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/recherche?q=${encodeURIComponent(searchQuery.trim())}`);
      setSearchOpen(false);
      setMobileMenuOpen(false);
      setSearchQuery('');
    }
  };

  return (
    <div>
      {/* Desktop & mobile navbar */}
      <div
        className={`
          fixed top-0 left-0 right-0 z-50 flex items-center justify-between transition-all duration-300
          ${scrolled ? 'bg-white' : 'bg-transparent'}
          py-4 px-6 md:px-10 lg:px-20
          rounded-b-[60px] md:rounded-b-[60px] lg:rounded-b-[60px]
        `}
      >
        {/* Logo */}
        <div className='flex items-center'>
          <NavLink to="/">
            <img src={Logo} className='w-12 md:w-16 lg:w-20 h-auto' alt='Logo' />
          </NavLink>
        </div>

        {/* Desktop Links */}
        <div className='hidden md:flex items-center text-[20px] justify-center font-regular gap-10 lg:gap-24'>
          {['Accueil', 'Produits', 'Services', 'Contact'].map((link, idx) => (
            <NavLink
              key={idx}
              to={`/${link === 'Accueil' ? '' : link}`}
              style={clashDisplay}
              className={`${scrolled ? 'text-black' : 'text-white'} font-semibold transition-all`}
            >
              {link}
            </NavLink>
          ))}
        </div>

        {/* Mobile Hamburger */}
        <div className='flex md:hidden items-center'>
          <button
            onClick={() => setMobileMenuOpen(true)}
            className={`${scrolled ? 'text-black' : 'text-white'} focus:outline-none`}
          >
            <div className='space-y-1'>
              <span className='block w-6 h-0.5 bg-current'></span>
              <span className='block w-6 h-0.5 bg-current'></span>
              <span className='block w-6 h-0.5 bg-current'></span>
            </div>
          </button>
        </div>

        {/* Desktop Search */}
        <div className='hidden md:flex items-center'>
          <button
            onClick={() => setSearchOpen(!searchOpen)}
            className={`${scrolled ? 'text-black' : 'text-white'} text-2xl`}
          >
            <FiSearch />
          </button>
        </div>
      </div>

      {/* Search Bar Overlay */}
      {searchOpen && (
        <div className="fixed top-20 right-10 z-50 bg-white shadow-lg rounded-xl p-3 w-72">
          <form onSubmit={handleSearch} className="flex items-center gap-2">
            <FiSearch className="text-gray-500 text-xl" />
            <input
              type="text"
              placeholder="Rechercher un produit..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full outline-none text-gray-700"
              autoFocus
            />
          </form>
        </div>
      )}

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div className='fixed inset-0 z-50 bg-black bg-opacity-90 flex flex-col items-center justify-center text-white'>
          {/* Close Button */}
          <button
            className='absolute top-6 right-6 text-white text-3xl'
            onClick={() => setMobileMenuOpen(false)}
          >
            &times;
          </button>

          {/* Mobile Links */}
          <div className='flex flex-col items-center gap-8 text-2xl'>
            {['Accueil', 'Produits', 'Services', 'Contact'].map((link, idx) => (
              <NavLink
                key={idx}
                to={`/${link === 'Accueil' ? '' : link}`}
                style={clashDisplay}
                className='hover:text-[#158DC1] transition-colors'
                onClick={() => setMobileMenuOpen(false)}
              >
                {link}
              </NavLink>
            ))}

            {/* Mobile Search */}
            <form onSubmit={handleSearch} className="flex items-center gap-3 mt-6">
              <FiSearch className="text-3xl cursor-pointer" onClick={handleSearch} />
              <input
                type="text"
                placeholder="Rechercher..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="bg-transparent border-b border-gray-400 focus:border-[#158DC1] outline-none px-2 text-white"
              />
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Navbar;